import React, { useEffect, useState } from "react";
import { BasicModalProps, Modal } from "../../components/Modal/Modal";
import styled from "styled-components";
import { Spinner } from "../../components/Loaders";
import { ConfirmIcon } from "../../components/Icons/ConfirmIcon";
import { ErrorIcon } from "../../components/Icons/ErrorIcon";
import { Media } from "../../styles";

interface CrateRevealProps extends BasicModalProps {
    revealTxState: string,
    mintedArtifacts: any[]
}

export const CrateReveal = ({
  isVisible,
  onClose,
  revealTxState,
  mintedArtifacts
}: CrateRevealProps) => {

  const titleText = revealTxState == 'Success' ? 'Success!' : revealTxState == 'Error' ? "Failed to open crates" : 'Opening your crates...'

  const rowLength = 5;
  const [artifactRows, setArtifactRows] = useState<any[]>([]);
  
  useEffect(() => {
    if(revealTxState == 'Success'){
        const newArtifactRows = []
        for(let i = 0; i < mintedArtifacts.length; i += rowLength){
            newArtifactRows.push(mintedArtifacts.slice(i, i + rowLength))
        }
        setArtifactRows(newArtifactRows)
    }
  }, [revealTxState])

  return (
    <StyledModal isVisible={isVisible} onClose={onClose}>
        <Title>
           {titleText}
        </Title>
        <CircleContainer>
            {revealTxState == 'Success' ? <ConfirmIcon/> : revealTxState == 'Error' ? <ErrorIcon/> : <Spinner/>}
        </CircleContainer>
        {
            revealTxState == 'Success' && 
            <>
                <Text>You received</Text>
                {artifactRows.map((artifactRow, index) => {
                    return (
                        <Row key={index}>                
                            {artifactRow.map((artifact : any) => {
                                return (
                                    <Artifact key={artifact.image}>
                                        <img src={`../../assets/booty/${artifact.image}.jpg`}/>
                                        <ArtifactBalance>{artifact.amount > 99 ? '99+' : artifact.amount}</ArtifactBalance>
                                    </Artifact>
                                )
                            })}
                        </Row>
                    )
                })}
            </>
        }
        {revealTxState == 'Submitted' && <Text style={{marginBottom: '12px'}}>Waiting for blockchain confirmation...</Text>}
        <ModalButton onClick={onClose}>Dismiss</ModalButton>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  height: fit-content;

  ${Media.mobile} {
    height: 85%;
    max-width: 100%;
    margin-top: 15.5%;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

`

const Title = styled.h3`
  font-weight: 500;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -0.03em;
  color: #ffffff;
`;

const CircleContainer = styled.div`
  width: 74px;
  height: 74px;
  margin: 24px auto;
  color: #00BDFF;

  > svg {
    margin: auto;
    height: 74px;
    width: 74px;
  }
`

const Text = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #7d7d97;
  text-align: center;
`;

const Artifact = styled.div`
  margin: 4px 4px;
  width: 64px;
  height: 64px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    border-radius: 16px;
    border: solid 2px #1E2239;
  } 
`

const ArtifactBalance = styled.p`

  position: absolute;
  min-width: 24px;
  min-height: 24px;
  font-weight: 10;
  font-size: 10px;
  line-height: 24px;
  text-align: center;
  margin-top: 34px;
  margin-left: 34px;

  border-radius: 12px;
  background: #00BDFF;
  color: #1E2239;
`

const Row = styled.div`
  display: flex;
  justify-content: center;
  margin: 8px;
`;

const ModalButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: fit-content;
  min-width: 156px;
  margin: auto auto 0;
  background: transparent;
  border: 1px solid #37dcf2;
  border-radius: 20px;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #ffffff;

  &:hover {
    background: linear-gradient(90.44deg, #37dcf2 0.87%, #07c0fb 100%);
    color: #000E47;
    border: solid 2px #000E47;
  }

  ${Media.mobile}{
    margin: 16px auto;
  }
`;